import { BUY_BONUS_TEXTS } from '@constants/buyBonusConstants'

// Only ACTIVE packages are purchasable, ordered by the BE's slab ordering —
// ports defenderV2's inline filter/sort in BuyFreebetsOverlay.js.
export const filterActivePackages = (packages = []) =>
  packages.filter((pkg) => pkg.status === 'ACTIVE').sort((a, b) => a.order - b.order)

// jackpotRatio is a multiplier (e.g. 1.5x); the copy states it as a bonus
// percentage over the baseline (1x = +0%). Ports defenderV2's
// calculateJackpotTicketsPercentage exactly.
export const jackpotRatioBonusPercentage = (jackpotRatio) => {
  const ratio = Number(jackpotRatio)
  if (Number.isNaN(ratio) || ratio <= 0) return 0
  return ratio * 100 - 100
}

export const formatJackpotRatioText = (jackpotRatio) =>
  BUY_BONUS_TEXTS.PACKAGES_LIST.JACKPOT_RATIO_TEXT.replace(
    '{x}',
    jackpotRatioBonusPercentage(jackpotRatio)
  )
